<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/gallery-designer.svg" size="2"></app-svg>
  <h1>Delete Theme?</h1>
  <p>Are you sure? This can't be undone.</p>
  <button
    appButton
    name="confirm"
    location="delete-gallery-theme-dialog"
    color="warn"
    data-test-id="delete-confirmation"
    (click)="confirm()"
    height="4"
    size="3"
    shape="round"
    weight="bold"
    spacing="full"
  >
    <span [class.hidden-text]="deleting()">Delete</span>
    @if (deleting()) {
      <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
    }
  </button>
  <button
    appButton
    name="cancel"
    location="delete-gallery-theme-dialog"
    color="simple-gray"
    (click)="close(false)"
    size="3"
    height="1"
    shape="round"
    weight="bold"
    class="sub-cta"
    [center]="true"
  >
    Cancel
  </button>
</div>
